export default {
  startingBillingPeriodId: {
    isRequiredTrim: {
      value: true,
    },
  },
  endingBillingPeriodId: {
    isRequiredTrim: {
      value: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/reports/forms/coverageStatuses/coverageStatusesValidationRules.js